export default "__VITE_ASSET__b4e878d6__"